import { render, staticRenderFns } from "./chat-histroy-new.vue?vue&type=template&id=7bef4d8a&scoped=true&"
import script from "./chat-histroy-new.vue?vue&type=script&lang=js&"
export * from "./chat-histroy-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bef4d8a",
  null
  
)

export default component.exports